var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM12.4191 6.46427L10.0001 8.88328L7.58099 6.4642C7.43294 6.31615 7.23213 6.23296 7.02275 6.23296C6.81337 6.23296 6.61256 6.31615 6.46451 6.4642C6.31645 6.61226 6.23327 6.81306 6.23327 7.02244C6.23327 7.23183 6.31645 7.43263 6.46451 7.58069L8.88358 9.99976L6.46449 12.4189C6.31644 12.5669 6.23326 12.7677 6.23326 12.9771C6.23326 13.1865 6.31644 13.3873 6.46449 13.5353C6.61255 13.6834 6.81335 13.7666 7.02274 13.7666C7.23212 13.7666 7.43292 13.6834 7.58098 13.5353L10.0001 11.1162L12.4191 13.5353C12.5671 13.6833 12.768 13.7665 12.9773 13.7665C13.1867 13.7665 13.3875 13.6833 13.5356 13.5353C13.6836 13.3872 13.7668 13.1864 13.7668 12.977C13.7668 12.7676 13.6836 12.5668 13.5356 12.4188L11.1166 9.99976L13.5356 7.58076C13.6836 7.4327 13.7668 7.23189 13.7668 7.02251C13.7668 6.81313 13.6836 6.61233 13.5356 6.46427C13.3875 6.31622 13.1867 6.23303 12.9773 6.23303C12.7679 6.23303 12.5671 6.31622 12.4191 6.46427Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleClear);
export default __webpack_public_path__ + "39448ee2190ed58a31547ffcc30db95f.svg";
export { ForwardRef as ReactComponent };